export default "__VITE_ASSET__KyFmqr86__"